import React from "react";

export const Customers = (props) => {
  return (
    <div id="customers">
      <div className="logo-bar-inner">
        <div className="logo-bar-label">Organizations We Serve</div>
        <div className="logo-bar-track">
          {props.data
            ? props.data.map((d, i) => (
                <div key={i} className="logo-bar-item">
                  <img src={d.img} alt="Customer logo" />
                </div>
              ))
            : null}
        </div>
      </div>
    </div>
  );
};
